import { Typography } from '@persona-id/design-tokens';
import qs from 'qs';
import styled from 'styled-components';

import CopyableField from 'dashboard/components/CopyableField';
import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import { Environment } from 'dashboard/models/environment';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { Organization } from 'dashboard/models/organization';
import { Template } from 'dashboard/models/template';
import { COLORS } from 'dashboard/styles/variables';
import { ApiModel } from 'lib/interfaces/api';
import { getRootDomain } from 'lib/utils/url';

const StyleWrapper = styled('a')`
  white-space: nowrap;

  input {
    ${Typography.TextMediumLink};
    color: ${({ theme }) => theme.color.text.brand};
    cursor: pointer;
    &:hover,
    &:focus {
      background-color: ${COLORS.indigo10};
    }
  }
`;

interface HostedFlowCodeSnippetProps {
  id?: string;
  template: Template | InquiryTemplate;
  environment: Environment;
  organization: Organization;
  showLabel?: boolean;
}

const HostedFlowCodeSnippet = ({
  id,
  template,
  environment,
  organization,
  showLabel = true,
}: HostedFlowCodeSnippetProps) => {
  const queryParams =
    template.type === ApiModel.Template
      ? {
          'template-id': template.id,
          'environment-id': environment.id,
        }
      : {
          'inquiry-template-id': template.id,
          'environment-id': environment.id,
        };

  // TODO(neal): set the default value for subdomain to inquiry after subdomain rolled out
  const subdomain = organization.attributes.subdomain;

  const link = `${location.protocol}//${[subdomain, getRootDomain(location.host)]
    .filter(Boolean)
    .join('.')}/verify?${qs.stringify(queryParams)}`;

  return (
    <div>
      {showLabel && (
        <FormControlLabel>
          Hosted flow link{environment.type === ApiModel.EnvironmentSandbox && ' (Sandbox)'}
        </FormControlLabel>
      )}
      <StyleWrapper href={link} target='_blank'>
        <CopyableField value={link} id={id} data-test={id} />
      </StyleWrapper>
    </div>
  );
};

export default HostedFlowCodeSnippet;
